import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Box, Container, Typography, Link, Button, Grid } from '@mui/material';
import { SimpleModal } from '@livable/saas-react-components';
import PostChargeModal from 'src/components/resident/PostChargeModal';
import ResidentModal from 'src/components/resident/ResidentModal';
import UpgradeEnrollTenantModal from 'src/components/tenant/UpgradeEnrollTenantModal';
import useStyles from '../styles';
const upgradePlanModalExample = "\nimport UpgradeEnrollTenantModal from './components/UpgradeEnrollTenantModal';\n\n<UpgradeEnrollTenantModal trigger={React.node} />";
const simpleModalExample = "\nimport { SimpleModal } from '@livable/saas-react-components';\n\n<SimpleModal\n  background\n  disabledTrigger={bool}\n  disableEscapeKeyDown={bool}\n  handleClose={func} // external control\n  handleOpen={func} // external control\n  isOpen={bool} // external control\n  leftButton={React.node}\n  noCloseButton={bool}\n  noFooter={bool}\n  noHeader={bool}\n  noPadding={bool}\n  rightButton={React.node} // for a single button\n  rightButtons={[React.node, React.node]} // for a few buttons\n  noLeftButton={bool}\n  subTitle=\"Second Line\"\n  title=\"Modal Header\"\n  trigger={React.node}\n  variant // default - 740px width, \"middle\" - 940px width, \"large\" - 1280px width\n  transparentBackdrop={bool}\n>\n  <Typography variant=\"h3\">modal content</Typography>\n  <Typography variant=\"body1\">modal content text</Typography>\n</SimpleModal>";
const modalWithSidebarExample = "\nimport { ModalWithSidebar } from '@livable/saas-react-components';\n\n<ModalWithSidebar\n  trigger={React.node}\n  title={string}\n  subTitle={string}\n  rightButton={React.node}\n  isOpen={bool} // external control\n  handleOpen={func} // external control\n  handleClose={func} // external control\n  tabs={ [{label: 'Overview', name: 'overview'}, ...] }\n  handleTabChange={func} // external control\n  selectedTab={'overview'} // external control\n  noInnerFooter={bool}\n  outerFooter={component}\n  noPadding={bool}\n  actionButton={React.node}\n  disabledTrigger={bool}\n  disabledTabs={bool}\n>\n  {selectedTab === 'overview' && <OverviewTab />}\n</ModalWithSidebar>";
export default function LvModals() {
  const classes = useStyles();
  const _useState = useState('overview'),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    tenantModalIsOpen = _useState4[0],
    setTenantModalIsOpen = _useState4[1];
  const openTenantModal = tab => {
    setActiveTab(tab);
    setTenantModalIsOpen(true);
  };
  const closeTenantModal = () => setTenantModalIsOpen(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, /*#__PURE__*/React.createElement("span", null, "Modals "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-modal/#basic-modal",
    target: "_blank"
  }, "(documentation)")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Upgrade plan modal"), /*#__PURE__*/React.createElement(UpgradeEnrollTenantModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "contained"
    }, "Upgrade modal")
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, upgradePlanModalExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "One line header"), /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "contained"
    }, "Open modal"),
    title: "Modal Header",
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained"
    }, "Primary")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    gutterBottom: true
  }, "Inform occupancy number changes to your property manager"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Some utility bills are dependent on occupancy numbers. Make sure to inform changes as they happen, so bill value will be calculated fairly."))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Two lines header"), /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "contained"
    }, "Open modal"),
    title: "Modal Header",
    subTitle: "Second Line",
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained"
    }, "Primary")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    gutterBottom: true
  }, "Inform occupancy number changes to your property manager"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Some utility bills are dependent on occupancy numbers. Make sure to inform changes as they happen, so bill value will be calculated fairly."))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, simpleModalExample))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Basic modal with sidebar"), /*#__PURE__*/React.createElement(PostChargeModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "contained"
    }, "Open modal")
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Modal with sidebar + outer footer"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: () => openTenantModal('overview')
  }, "Open modal"), /*#__PURE__*/React.createElement(ResidentModal, {
    isOpen: tenantModalIsOpen,
    handleOpen: openTenantModal,
    handleClose: closeTenantModal,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, modalWithSidebarExample))))));
}